import type { VoidComponent } from "solid-js";
import { createSignal, getOwner, runWithOwner } from "solid-js";
import { FieldsAccordion } from "../../../components/accordion/Accordion";
import { categories } from "../../../fields/fields";
import { getCategoryTranslationKey } from "../../../utils/translationUtil";
import type { Category } from "../../../types";
import { useTranslation } from "../../../state/i18n";
import SearchBar from "../../../components/searchBar/SearchBar";
import { useFormServices } from "../../../services/formServices";
import EmptyState from "../../../components/emptyState/EmptyState";
import { scrollToField } from "../../../utils/fieldUtil";

const EditorMenuFields: VoidComponent = () => {
  const { t } = useTranslation();
  const { fieldService } = useFormServices();
  const [query, setQuery] = createSignal("");
  const owner = getOwner();

  return (
    <>
      <div class="mx-3 mb-3">
        <SearchBar
          query={query()}
          onQueryChange={(value) => {
            setQuery(value);
          }}
          placeholder={t(($) => $.FIELDS_SEARCH_PLACEHOLDER)}
        />
      </div>
      <div class="flex flex-1 overflow-y-auto px-3 -outline-offset-1 focus-visible:outline-default">
        <FieldsAccordion
          initialClosed={false}
          items={Object.entries(categories).map(([category, fields]) => ({
            label: t(getCategoryTranslationKey(category as Category)),
            key: category,
            components: fields
              .filter((field) => field.canAddToForm())
              .map((field) => ({
                Component: () => (
                  <field.MenuItem
                    addFunction={() => {
                      runWithOwner(owner, () => {
                        const createdField = fieldService.createField(field.type);
                        fieldService.addFieldToEnd(createdField);
                        scrollToField(createdField.uid, "smooth");
                      });
                    }}
                  />
                ),
                filterKey: t(field.titleKey),
              })),
          }))}
          filterQuery={query()}
          EmptyState={() => (
            <EmptyState
              title={t(($) => $.FIELDS_SEARCH_EMPTY_STATE_TITLE)}
              description={t(($) => $.FIELDS_SEARCH_EMPTY_STATE_DESCRIPTION)}
            />
          )}
        />
      </div>
    </>
  );
};

export default EditorMenuFields;
